/**
 * Algorand JavaScript SDK
 * @external algosdk
 * @see {@link https://algorand.github.io/js-algorand-sdk/}
 */

module.exports = require('./AlgodexApi');
